// @flow

export const facetArrayToObject = (facetsArray: Array<Object> = []) => {
  const obj = {};
  facetsArray.forEach(facet => {
    obj[facet.value] = facet.value;
  });
  return obj;
};

export const facetToBoolean = (facet: Array<Object>) => {
  const isFacetWithValue = facet && typeof facet[0] !== 'undefined' && facet[0].value;

  if (isFacetWithValue) {
    return facet[0].count;
  }

  return 0;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/facets.js